import script from "./GamesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GamesView.vue?vue&type=script&setup=true&lang=ts"

import "./GamesView.vue?vue&type=style&index=0&id=4f16cabd&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f16cabd"]])

export default __exports__